export const navSimulationItems = [
  {
    link: "/simulacion/pendiente",
    text: "Pendientes",
  },
  {
    link: "/simulacion/expirada",
    text: "Expiradas",
  },
  {
    link: "/simulacion/nueva",
    text: "Nueva",
  },
];

export const navHiringItem = [
  {
    link: "/contratacion/pendiente",
    text: "Pendientes",
  },
  {
    link: "/contratacion/realizada",
    text: "Realizadas",
  },
  {
    link: "/contratacion/pendiente?new=true",
    text: "Nueva",
  },
];

export const NAV_CLIENTS_LINK = {
  POLIZAS_CLIENTES: "/polizas-clientes",
  RECIBOS_CLIENTES: "/recibos-clientes",
  FICHEROS_EIAC: "/ficheros-eiac",
  INFORMES:  "/informes",
  CUADRO_MANDO: "/cuadro-de-mando",
  RECOBROS: "/recobros",
  RECOBROS_PENDIENTES: "/solicitudes-pendientes",
  RECOBROS_FINALIZADOS: "/solicitudes-finalizadas",
};

export const navClientsItem = [
  {
    link: NAV_CLIENTS_LINK.CUADRO_MANDO,
    text: "Cuadro de mando",
  },
  // {
  //   link: "/facturas",
  //   text: "Facturas",
  // },
  {
    link: NAV_CLIENTS_LINK.FICHEROS_EIAC,
    text: "Ficheros EIAC",
  },
  {
    link: NAV_CLIENTS_LINK.INFORMES,
    text: "Informes",
  },
    /* {
    link: "/liquidaciones-clientes",
    text: "Liquidaciones",
  }, */
  {
    link: NAV_CLIENTS_LINK.POLIZAS_CLIENTES,
    text: "Pólizas",
  },
  {
    link: NAV_CLIENTS_LINK.RECIBOS_CLIENTES,
    text: "Recibos",
  },
  {
    link: NAV_CLIENTS_LINK.RECOBROS,
    text: "Recobros",
    dropdownItems: [
      {
        link: NAV_CLIENTS_LINK.RECOBROS_PENDIENTES,
        text: "Solicitudes pendientes",
      },
      {
        link: NAV_CLIENTS_LINK.RECOBROS_FINALIZADOS,
        text: "Solicitudes finalizadas",
      }
    ]
  }
];

export const navClientsItemSuplemento = [
  {
    link: "/suplementos",
    text: "Suplementos",
  },

];

export const navSecurityItems = [
  {
    link: "/permisos",
    text: "Permisos",
  },
  {
    link: "/gestion-privilegios",
    text: "Privilegios",
  },
];

export const navAdminItems = [
  {
    link: "/gestor-campañas",
    text: "Campañas",
  },
  {
    link: "/actualizacion-solicitudes",
    text: "Estados de solicitud",
  },
  {
    link: "/gestor-notificaciones",
    text: "Notificaciones",
  },
];
